import { type Device } from '../../../common/types';

interface IProps {
  devices: Device[];
}

const RecentDevices: React.FC<IProps> = ({ devices }) => {
  return (
    <div className="w-full p-2 my-2 overflow-auto flex flex-col space-y-2 border-b-gray-50">
      {devices.map((device) => {
        return (
          <div
            key={`recent-device-${device.id}`}
            className="w-full bg-gray-50 p-4 flex justify-between justify-items-center items-center rounded-md"
          >
            <span>{device.name}</span>
            <span>{device.email}</span>
          </div>
        );
      })}
    </div>
  );
};

export default RecentDevices;
